// Transaction error messages
export const MSG_BILLING_CONTACT_ERROR = 'There was an issue with the billing contact information. Please verify your information and try again. If you continue to receive this message and feel it is in error, please contact info@akc.org or AKC Customer Service at 919-233-9767';
export const MSG_DECLINED_PAYMENT_AUTH_ERROR = 'The credit card you provided was declined. Please verify your information and try again.';
export const MSG_DECLINED_PAYMENT_AUTH_ERROR_ATTEMPTS = 'The credit card you provided was declined. Please verify your information and try again. If you continue to receive this message and feel it is in error, please contact info@akc.org or AKC Customer Service at 919-233-9767';
export const MSG_UNABLE_TO_COMPLETE_TXN = 'We are unable to complete transaction number {transactionNum}.  Please contact AKC Customer Service at 919-233-9767.  Error code {errorCode}';
export const MSG_UNEXPECTED_ERROR = 'An unexpected error has occurred. Please try again. If you continue to receive this message, please contact info@akc.org or AKC Customer Service at 919-233-9767';
// Transaction status constants
export const STATUS_DECLINED = 'DECLINED';
export const STATUS_FAILED_CONTACT = 'FAILED_CONTACT';
// Page constants
export const FOOTER_PHONE_NUMBER = '919-816-3767';
export const FOOTER_EMAIL = 'titlerecognition@akc.org';
export const GIFT_ACCESS_CODE_PROGRAM = 'GDH-GIFT';
export const CUSTOMER_RELATION_TYPE = 'CUSTNM';
export const CONTACT_RCPNT_TYPE = 'RCPNT';
export const CONTACT_RQSTR_TYPE = 'RQSTR';
export const ACTION_CONTINUE = 'CONTINUE';
export const ACTION_COMP_TXN = 'COMP_TXN';
export const GIFT_CARD_REGISTRATION_PROGRAM = 'GDH_OL_GIFT_ENROLL';
export const GIFT_ENROLL_PATH = '/giftcard';
export const NEW_ENROLL_PATH = '/new-enrollment';

// Geo constants
export const DEFAULT_COUNTRY = 'USA';
export const COUNTRIES_WITH_STATES = [DEFAULT_COUNTRY, 'CAN', 'MEX'];

// Utility constants
export const UTILITY_URL = '/client-utility/v1/client-information';

// Google Analytics
export const GA_MEASUREMENT_ID = 'UA-2957907-1';

// Messages constants
export const CANCEL_RENEWAL = 'This transaction will be canceled and you will need to start a new application if you wish to renew the enrollment for this dog(s). This action cannot be undone.';
export const CANCEL_ENROLLMENT = 'This transaction will be canceled and you will need to start a new application if you wish to enroll this dog. This action cannot be undone.';
export const REDEEM_GIFT_NUMBER_TOOLTIP = 'Your gift card number is located on the back of the card under a scratch off coating.';
export const MISSING_CUSTOMER_PHONE_NUMBER = `The customer information required to renew your subscription is incomplete. Please contact info@akc.org or AKC Customer Service at 919-816-3918 to have this updated so that you may proceed.`;
export const MISSING_CUSTOMER_PHONE_NUMBER_TITLE = 'Incomplete customer information';

// state constants
export const STATE_COMPLETE = 'COMPLETE PURCHASE';
export const STATE_CONTINUE = 'CONTINUE';
export const STATE_VALID = 'INFO_VALID';
export const STATE_COMP_TXN = 'COMP_TXN';
export const AUTHORIZED = 'AUTHORIZED';

// type constants
export const TYPE_BILING = 'BILING';
